import {twMerge} from '@sdox/utils'

import {GalleryItem} from '../Gallery/GalleryItem'
import {Slideshow} from '../Slideshow'

import type {GalleryProps} from './Gallery'

export const ThumbnailGallery = ({
  items = [],
  galleryComponent,
  className,
  ...restProps
}: GalleryProps) => (
  <Slideshow items={items}>
    {({show}) => (
      <div
        className={twMerge('@container/block', className)}
        {...restProps}
      >
        <div
          className={twMerge(
            'grid gap-spacing-2 overflow-hidden rounded-radius-md',
            'grid-cols-2 @block-large:grid-cols-3',
          )}
        >
          {items.slice(0, 6).map(({src, placeholderSrc}, index) => {
            if (!src) return null
            let counterClassName = 'hidden'
            let expandIndicatorClassName = 'opacity-0 duration-300 group-hover:opacity-100'
            if (items.length > 4 && index === 3) {
              counterClassName = 'flex @block-large:hidden'
              expandIndicatorClassName = 'opacity-0 @block-large:group-hover:opacity-100'
            } else if (items.length > 6 && index === 5) {
              counterClassName = 'flex'
              expandIndicatorClassName = 'hidden'
            }

            return (
              <GalleryItem
                key={index}
                index={index}
                src={src}
                placeholderSrc={placeholderSrc}
                onClick={() => show(index)}
                imagesLength={items.length}
                className={index > 3 && 'hidden @block-large:block'}
                counterClassName={counterClassName}
                expandIndicatorClassName={expandIndicatorClassName}
              />
            )
          })}
        </div>
        {galleryComponent}
      </div>
    )}
  </Slideshow>
)
